<template>
    <div>
        <veui-button ui="primary"
            class="f-topic-official-more-audit-btn"
            @click="reviewOfficialReply(1)">
            审核通过
        </veui-button>
        <veui-button ui="primary"
            class="f-topic-official-more-audit-btn"
            @click="reviewOfficialReply(2)">
            审核不通过
        </veui-button>

        <!-- 打回审核填写原因弹窗 -->
        <veui-prompt-box
            v-if="auditRejectOpen"
            :open.sync="auditRejectOpen"
            @ok="auditRejectReply"
            @cancel="cancel"
        >
            确认打回审核吗？请简单描述下原因：
        </veui-prompt-box>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/official-process/official-process-board.less';
</style>

<script>
import {Button, PromptBox} from 'veui';
import {mapState} from 'vuex';
import {throttle} from '@/utils/debounceThrottle';
import toast from 'veui/managers/toast';
import {notAllowScroll, allowScroll, scrollToId} from '@/utils/decorate/scroll';

export default {
    data() {
        return {
            auditRejectOpen: false
        };
    },
    components: {
        'veui-button': Button,
        'veui-prompt-box': PromptBox
    },
    computed: {
        ...mapState({
            showTips: state => state.topicContent.showTips
        })
    },
    methods: {
        reviewOfficialReply(type) {
            // 1-通过 2-打回
            if (type === 1) {
                this.$emit('openwindow', 'audit-pass');
            }
            else {
                this.auditRejectOpen = true;
                notAllowScroll();
            }
        },
        auditRejectReply: throttle(function (auditRejectDesc) {
            if (auditRejectDesc.trim().length === 0) {
                toast.info(this.showTips.withoutAuditRejectDesc);
                return;
            }
            this.$store.dispatch('reviewOfficialReply', {
                type: 2,
                auditDescription: auditRejectDesc
            })
                .then(() => {
                    this.cancel();
                    scrollToId('official-board');
                });
        }),
        cancel() {
            this.auditRejectOpen = false;
            allowScroll();
        }
    }
};
</script>
